import rawConfig from '../site.config.json'

export interface SiteConfig {
  canonicalOrigin: string
  aliasOrigins: string[]
  brandName: string
  publicIdentity: { schemaType: 'Organization'; name: string; url: string }
  /** Public creative identity used by the legacy map-export content contract. */
  creator: { schemaType: 'Organization'; name: string; url: string }
  parentProduct: { name: string; url: string }
  contactEmail: string
  apiOrigin: string
  dataOrigin: string | null
  dataReleasePrefix: string | null
  dataRemotePrefixes: string[]
  clarityProjectId: string
  ga4MeasurementId: string
  cloudflareWebAnalyticsToken: string
  turnstileSiteKey: string
  audienceEnabled: boolean
}

const publicIdentity = Object.freeze(rawConfig.publicIdentity as SiteConfig['publicIdentity'])

export const siteConfig = Object.freeze({
  ...rawConfig,
  publicIdentity,
  creator: publicIdentity,
  audienceEnabled: rawConfig.audienceEnabled === true,
} as SiteConfig)

export function canonicalHost(): string {
  return new URL(siteConfig.canonicalOrigin).host
}
